module.exports = __webpack_public_path__ + "media/images/plastic_black-16e5cfcf.png";